<template>
    <div class="h-full">
        <Head :title="__(title)"/>
        <div class="flex flex-col flex-grow-1 flex-shrink-1 h-full">

            <div class="flex flex-col task__table overflow-y-auto h-full">
                <div class="inline-block min-w-full h-full py-4 align-middle md:px-3 lg:px-4">
                    <select-input class="pb-2 pr-6 w-full lg:w-1/6" :label="__('Select user')"
                                  v-model="selectedUser"
                                  @change="fetchAttendance(selectedUser)"
                    >
                        <option value=""> Select User</option>
                        <option v-for="u in users" :key="u.id" :value="u.id">
                            {{ u.name }}
                        </option>
                    </select-input>

                    <div v-if="calendarView" id="ec_module" class="calendar-container">
                        <Qalendar
                            :events="calendarEvents"
                            :selected-date="getRequestDate()"
                            :config="evConfig"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Layout from '@/Shared/Layout'
import {Head, Link} from '@inertiajs/vue3'
import moment_timezone from 'moment-timezone'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import SelectInput from '@/Shared/SelectInput'
import {ref} from 'vue'

import BoardViewMenu from '@/Shared/BoardViewMenu'
import {Qalendar} from 'qalendar'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
    metaInfo: {title: 'FAQs'},
    components: {
        Link,
        Head,
        Datepicker,
        Qalendar,
        BoardViewMenu,
        SelectInput
    },
    layout: Layout,
    props: {
        auth: Object,
        title: String,
        tasks: Object,
        filters: Object,
        project: Object,
        list_index: Object,
        board_lists: Object,
        users: Array,
        lists: {
            required: false,
        },
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.route('projects.view.calendar', this.project.slug || this.project.id), pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    remember: 'form',
    setup() {
        let dateOverride = ref(null)
        const closeOverrideCalendar = () => {
            if (!!dateOverride.value && dateOverride.value.length) {
                dateOverride.value[0].closeMenu()
            }
        }
        return {
            dateOverride,
            closeOverrideCalendar,
        }
    },
    data() {
        return {
            selectedUser : '',
            calendarView: false,
            open_filter: false,
            calendarEvents: [],
            evConfig: {
                style: {
                    colorSchemes: {},
                },
                week: {
                    // Takes the value 'sunday' or 'monday'
                    // However, if startsOn is set to 'sunday' and nDays to 5, the week displayed will be Monday - Friday
                    startsOn: 'monday',
                    // Takes the values 5 or 7.
                    nDays: 7,
                    // Scroll to a certain hour on mounting a week. Takes any value from 0 to 23.
                    // This option is not compatible with the 'dayBoundaries'-option, and will simply be ignored if custom day boundaries are set.
                    scrollToHour: 5,
                    weekHeight: '3400px',
                },
                month: {
                    // Hide leading and trailing dates in the month view (defaults to true when not set)
                    showTrailingAndLeadingDates: false,
                },
                // defaultMode: this.filters.view || 'week',
                defaultMode: 'month',
                // The silent flag can be added, to disable the development warnings. This will also bring a slight performance boost
                isSilent: true,
                showCurrentTime: true, // Display a line indicating the current time
            },
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
                view: ['calendar'].includes(this.filters.period) ? this.filters.view : null,
                range: ['range', 'calendar'].includes(this.filters.period) ? this.filters.range : null,
            },
            event_dates: {},
            rangeDate: null,
        }
    },
    methods: {
        getRequestDate() {
            return new Date()
        },
        /*crossEvent(id) {
            const findCrossEventIndex = this.events.data.findIndex(e => e.id = id)
            console.log(findCrossEventIndex)
            this.events.data[findCrossEventIndex].is_active = false
        },

        selectRange() {
            console.log(this.rangeDate)
            this.form.range = {start: this.rangeDate[0], end: this.rangeDate[1]}
            this.form.period = 'range'
        },
        activeTab(index) {
            for (const tab_item of this.tabs) {
                tab_item.active = false
            }
            if (this.tabs[index].period === 'range') {

            } else {
                this.form.period = this.tabs[index].period
            }
        },
        filter() {

        },
        handleDateUpdate(obj) {
            this.form.range = {
                start: this.moment(obj.start).format('YYYY-MM-DD'),
                end: this.moment(obj.end).format('YYYY-MM-DD'),
            }
            this.form.period = 'calendar'
            this.form.view = this.filters.view || 'week'
        },
        handleModeUpdate(obj) {
            this.form.range = {
                start: this.moment(obj.period.start).format('YYYY-MM-DD'),
                end: this.moment(obj.period.end).format('YYYY-MM-DD'),
            }
            this.form.view = obj.mode
        },
         */
        processData() {
            this.event_dates = {}
            const created_at = this.moment().format('YYYY-MM-DD HH:mm')
            const absent = this.moment('2024-12-08', 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm')
            const due_date = this.moment().format('YYYY-MM-DD HH:mm')
            const html = ' Hi'

            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })
            this.calendarEvents.push({
                title: 'present',
                time: {start: created_at, end: due_date || created_at},
                description: html,
                style: { backgroundColor: '#CE4141', color: '#FFFFFF' },
                className: 'absent-event',
                // time: { start: this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm'), end: this.moment(event_item.date+' '+event_item.end, 'YYYY-MM-DD h:mma').format('YYYY-MM-DD HH:mm') },
                id: 10,
            })


            this.calendarEvents.push({
                title: 'absent',
                time: { start: absent, end: absent },
                description: html,
                'color': '#CE4141',
                'backgroundColor': '#CE4141',
                textColor: '#CE4141',
                id: 11,
            });
            this.calendarView = true
        },
        fetchAttendance(id){

        }
    },
    mounted() {
        this.processData()
    },
    created() {
        this.moment = moment_timezone
    },
}
</script>
